import { deburr, isNil } from "lodash";

export const NEEDS_PATH_PREFIX = "project.needs.";

const NEEDS_ACCESSOR_PREFIX = "fields.needs.";

// Keep identical to the API `needs-fields.ts`. The apps do not share a module.
const NEED_LIKE_PATTERN = /^(besoin|need)/i;

export const isNeedsPath = (path) =>
  typeof path === "string" &&
  path.startsWith(NEEDS_PATH_PREFIX) &&
  path.length > NEEDS_PATH_PREFIX.length;

export const needsPathOfAccessor = (accessor) =>
  typeof accessor === "string" &&
  accessor.startsWith(NEEDS_ACCESSOR_PREFIX) &&
  accessor.length > NEEDS_ACCESSOR_PREFIX.length
    ? `project.${accessor.slice("fields.".length)}`
    : null;

export const needsCategoryOf = (path) =>
  isNeedsPath(path) ? path.slice(NEEDS_PATH_PREFIX.length) : null;

export const looksLikeNeed = (text) =>
  NEED_LIKE_PATTERN.test(deburr(String(isNil(text) ? "" : text).trim()));

export const needsPathsOf = (variables) =>
  (variables || [])
    .map((variable) => variable.field)
    .filter((path) => isNeedsPath(path));
